module.exports = __webpack_public_path__ + "static/media/cutsheet.b1010a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flexhouse/cutsheet.jpg
// module id = 360
// module chunks = 0